import React, {useState, useContext, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { signIn, confirmSignIn } from 'aws-amplify/auth';
import PasswordStrengthIndicator from '../../components/passwordStrengthIndicator';
//import { useSnackbar } from 'notistack';
import { ProductContext } from '../../ProductProvider';
//import Preloader from '../../components/Preloader/Preloader';
//import logo from '../../images/logo/logo-new.png';
import { RoutesLocal } from '../../routes';
//import {Helmet} from 'react-helmet-async';
import logo from '../../assets/images/logo/arlogo.png';

const isNumberRegx = /\d/;
const specialCharacterRegx = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
const capsRegx=/[A-Z ]+/;
const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default function Login() {
  const { validateLogin, loginValidated, setLoginValidated, loggedUser } = useContext(ProductContext);
  //const { enqueueSnackbar } = useSnackbar();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showNewPass, setShowNewPass] = useState(false);
  const [newPassword, setNewPassword]=useState('');
  const [loaded, setLoaded] = useState(true);
  const [passwordValidity, setPasswordValidity] = useState({
      minChar: null,
      number: null,
      specialChar: null,
      capsChar:null
    });
    const [passwordFocused, setPasswordFocused] = useState(false);
    const [newpasswordFocused, setNewPasswordFocused] = useState(false);
    const [newpasswordValidity, setNewPasswordValidity] = useState({
      minChar: null,
      number: null,
      specialChar: null,
      capsChar:null
    });
  
    useEffect(() => {
      if(!loggedUser.isAuthenticated && !loginValidated){
        setLoginValidated(true);
        validateLogin();
      }
    }, [])
  

const handleLogin = async(event) => {
  event.preventDefault();
  try{
      setLoaded(false);
      setNewPasswordFocused(false);
      if(username===""||password===""){
        //enqueueSnackbar("Username and Password cannot be empty",{variant:'info'});
        setLoaded(true);
      }else if(!username.match(validRegex)){
        //enqueueSnackbar("Enter your registered eamil address!",{variant:'info'});
      }else{
   await signIn({ 
    username, 
    password,
    })
   .then(async(user)=>{
    console.log("User" , user);
    if(!user.isSignedIn && user.nextStep.signInStep==="CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"){
      //setUser(user);
      setPasswordFocused(false);
      setShowNewPass(true);
     // enqueueSnackbar("Set up your New Password",{variant:'info'});
    }else{  
      await validateLogin();
   }
   setLoaded(true);
  })
   .catch((error)=>{
    console.log("Error :", error);
    setLoaded(true);
    //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
   })
}
    }catch(error){
      //console.log("Error", error);
      setLoaded(true);
      //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});            
    }
};

const handleChangePassword =async(event)=>{
  event.preventDefault();
  try{
    setLoaded(false);
    const attributes = {
      email: username,
     };
     await confirmSignIn({
      challengeResponse: newPassword,
     })
    .then(async(user) => {
      //console.log(user);
      if(user.isSignedIn){
        await validateLogin();
       // enqueueSnackbar("Authenticated Successfully!",{variant:'success'});
        setLoaded(true);    
      }
      //setSidebarStatus("Orginal");
  }).catch(e => {
    setLoaded(true);
   // enqueueSnackbar("Error Occured - " + e.message,{variant : 'warning'});
  });
  }catch(error){
    setLoaded(true);
   // enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
  }
}

const onChangePassword = password => {
  setPassword(password);
  setPasswordValidity({
      minChar: password.length >= 8 ? true : false,
      number: isNumberRegx.test(password) ? true : false,
      specialChar: specialCharacterRegx.test(password) ? true : false,
      capsChar:capsRegx.test(password)?true:false
  });
};

const onNewChangePassword = password => {
  setNewPassword(password);
  setNewPasswordValidity({
    minChar: password.length >= 8 ? true : false,
    number: isNumberRegx.test(password) ? true : false,
    specialChar: specialCharacterRegx.test(password) ? true : false,
    capsChar:capsRegx.test(password)?true:false
  });
};


  return (
    <div>
    <main>
    <div className="container">
      <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-2">
        <div className="container" style={{backgroundColor:"#f7fafc", borderRadius:"12px", padding:"2rem", boxShadow: "0 6px 18px rgba(0,0,0,0.08)"}}>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
              <div className="d-flex justify-content-center py-1">
                <a href="https://archivesj.in" className="d-flex align-items-center w-auto">
                  <img src={logo} alt="" style={{width:"90px", height:"90px"}} />
                </a>
              </div>
              <h2 className="d-none d-lg-block ">Admin Office - Archives</h2>
              <div className="card mb-3">
                <div className="card-body">
                  <div className="pt-2 pb-2">
                    <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                    <p className="text-center small">Enter your registered email & password to sign in</p>
                  </div>
                  <form className="row g-3 needs-validation" noValidate>
                    <div className="col-12">
                      <label htmlFor="yourUsername" className="form-label">Email</label>
                      <div className="input-group has-validation">
                        <span className="input-group-text" id="inputGroupPrepend">@</span>
                        <input type="email" name="username" className="form-control" id="yourUsername" required
                        onChange={event=>setUsername(event.target.value)} value={username}/>
                        <div className="invalid-feedback">Please enter your username.</div>
                      </div>
                    </div>

                    {!showNewPass?<div className="col-12">
                      <label htmlFor="yourPassword" className="form-label">Password</label>
                      <input type="password" name="password" className="form-control" id="yourPassword" required 
                      onFocus={() => setPasswordFocused(true)}
                      onChange={e =>
                          onChangePassword(e.target.value)}            
                                  value={password}/>
                      {passwordFocused && <PasswordStrengthIndicator validity={passwordValidity} />}
                      <div className="invalid-feedback">Please enter your password!</div>
                    </div>:<div className="col-12">
                      <label htmlFor="yourNewPassword" className="form-label">New Password</label>
                      <input type="password" name="newpassword" className="form-control" id="yourNewPassword" required 
                      onFocus={() => setNewPasswordFocused(true)}
                      onChange={e =>
                          onNewChangePassword(e.target.value)}            
                    value={newPassword}/>
                      {newpasswordFocused && <PasswordStrengthIndicator validity={newpasswordValidity} />}
                      <div className="invalid-feedback">Please enter your New password!</div>
                    </div>}

                    <div className="col-12">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe"/>
                        <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
                      </div>
                    </div>
                    <div className="col-12">
                    {!showNewPass?<button className="btn btn-primary w-100 rounded-pill shadow-sm" type="submit" onClick={event=>handleLogin(event)}>Sign In</button>
                    :<button className="btn btn-primary w-100 rounded-pill shadow-sm" type="submit" onClick={event=>handleChangePassword(event)}>Change Password</button>} 
                    </div>
                    {/*<div className="col-12">
                      <p className="small mb-0">Don't have account? <a href="pages-register.html"><Link to={RoutesLocal.Signup.path}>Create an account</Link></a></p>
                    </div>*/}
                    <div className="col-12">
                      <p className="small mb-0">Forgot Password? <a href="pages-register.html"><Link to={RoutesLocal.ForgotPassword.path}>Reset Password</Link></a></p>
                    </div>

                  </form>

                </div>
              </div>

              {/*<div className="credits">
                <!-- All the links in the footer should remain intact. -->
                <!-- You can delete the links only if you purchased the pro version. -->
                <!-- Licensing information: https://bootstrapmade.com/license/ -->
                <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/nice-admin-bootstrap-admin-html-template/ -->
                Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
              </div>*/}

            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
    </div>
  )
}
